<template>
  <!-- Header -->
  <div class="container-fluid">
    <Home />
  </div>
  <!-- Footer -->
</template>

<script>
import Home from "@/views/Home";

export default {
  name: "App",
  components: {
    Home,
  },
};
</script>

<style></style>
